import React from 'react'
import Footer from '../components/footerComponent/footer'
import Access from '../components/paymentsComponent/accessComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function AccessPage() {
    return (
        <Layout>
            <Header/>
            <Access/>
            <Footer/>
        </Layout>
    );
};